export const errorCodes = {
    CURRENCY_DOES_NOT_MATCH: 'currency-does-not-match',
    NEW_PAYMENT_GATEWAY: 'new-payment-gateway',
    CHART_OF_ACCOUNT_NOT_FOUND: 'chart-of-account-not-found',
    BANK_ACCOUNT_NOT_FOUND: 'bank-account-not-found',
    CLEARING_ACCOUNT_NOT_FOUND: 'clearing-account-not-found',
    IMPORT_TRANSACTIONS_PAUSED: 'import-transactions-paused',
    INTEGRATION_DELETED: 'integration-deleted',
    INTEGRATION_BLOCKED: 'integration-blocked',
    INVOICE_LIMIT_REACHED: 'invoice-limit-reached',
    CONTACT_NOT_FOUND: 'contact-not-found',
    ERROR_CONNECTION: 'error-connection',
    CONNECTION_ERROR: 'connection-error',
    BILLING_SUBSCRIPTION_CANCELLED: 'billing-subscription-cancelled',
    FORBIDDEN: 'forbidden',
    UNAUTHORIZED: 'unauthorized',
    ACCOUNT_NAME_NOT_UNIQUE: 'account-name-not-unique',
    FREE_TRIAL_EXPIRED: 'free-trial-expired',
    TAX_RATE_NOT_FOUND: 'tax-rate-not-found',
    TAX_RATE_INCORRECT: 'tax-rate-incorrect',
    MISSING_TRANSACTION_TYPE_MAPPING: 'missing-transaction-type-mapping',
    INSUFFICIENT_USER_PERMISSIONS: 'insufficient-user-permissions',
};
